
export default function BrandSection() {
  return (
    <div className="tw-bg-white tw-py-8 tw-flex tw-justify-center">
      <div className="tw-max-w-6xl tw-mx-auto tw-px-6 tw-flex tw-items-center [&>img]:tw-max-w-[136px] ">
        <img src="/nestroot/nestroot-logo.png" alt="Nestroot" className="tw-py-4 tw-px-5" />
        <img
          src="/nestroot/logo-dark.png"
          alt="Protega"
          className=" tw-border-l-2 tw-border-black tw-py-4 tw-px-5"
        />
      </div>
    </div>
  );
}
